import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

const ToggleOnOffButton = ({ checked, onToggle, onLabel = 'Enable', offLabel = 'Disable', icon = false }) => {
  return (
    <button
      type="button"
      onClick={() => onToggle(!checked)} // Pass the updated state to parent
      style={{
        padding: icon ? '3px' : '8px 20px',
        fontSize: '14px',
        background: checked
          ? 'linear-gradient(145deg, #4cd964, #3acb57)'
          : 'linear-gradient(145deg, rgb(185, 0, 0), rgb(200, 0, 0))',
        color: '#ffffff',
        border: 'none',
        borderRadius: icon ? '3px' : '25px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        cursor: 'pointer',
        transition: 'background 0.3s ease, transform 0.2s ease',
        outline: 'none',
      }}
      onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
      onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      {icon ?
        (checked ? <CheckIcon style={{ verticalAlign: 'middle' }} /> : <CloseIcon style={{ verticalAlign: 'middle' }} />)
        : (checked ? onLabel : offLabel)
      }
    </button>
  );
};

export default ToggleOnOffButton;
